import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { OrderStatus, ShippingType } from '@services/orders/interfaces/orders.interfaces';

import { statusLabelFor } from '@constants/orders.constants';

/** Maps an order status to its badge colour modifier. */
const STATUS_MODIFIERS: Record<OrderStatus, string> = {
  pending: 'status-badge--pending',
  shipped: 'status-badge--shipped',
  completed: 'status-badge--completed',
  cancelled: 'status-badge--cancelled',
  returned: 'status-badge--returned',
  payment_failed: 'status-badge--payment-failed',
};

@Component({
  selector: 'app-order-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './order-status-badge.component.html',
  styleUrl: './order-status-badge.component.css',
})
export class OrderStatusBadgeComponent {
  public readonly status = input.required<OrderStatus>();
  public readonly shippingType = input.required<ShippingType>();

  protected readonly label = computed(() => statusLabelFor(this.status(), this.shippingType()));
  protected readonly modifier = computed(() => STATUS_MODIFIERS[this.status()]);
}
